import {Pathology} from '@legit-health/ui';

export default function isHidradenitisSuppurativa(pathology: Pathology) {
  return pathology.code.toLowerCase() === 'hidradenitis suppurativa'.toLowerCase();
}
